export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-xl p-8">
        <h1 className="text-4xl font-bold text-gray-900 mb-2">
          Privacy Policy
        </h1>

        <p className="text-gray-600 mb-8">
          Last Updated: August 2026
        </p>

        <div className="space-y-8 text-gray-700">
          <section>
            <h2 className="text-2xl font-semibold mb-3">
              1. Introduction
            </h2>
            <p>
              DBSkills Attendance respects your privacy and is committed to
              protecting your personal information. This Privacy Policy explains
              how we collect, use, store, and protect information when you use
              our application.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">
              2. Information We Collect
            </h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Employee Name</li>
              <li>Email Address and Login Credentials</li>
              <li>Attendance Records</li>
              <li>Location Data (GPS)</li>
              <li>Device Information</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">
              3. How We Use Information
            </h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Manage employee attendance records</li>
              <li>Verify attendance location</li>
              <li>Generate attendance reports</li>
              <li>Maintain and improve application performance</li>
              <li>Provide user support</li>
              <li>Maintain application security</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">
              4. Location Data
            </h2>
            <p>
              DBSkills Attendance collects location information when a user
              records attendance. Location data is used for attendance
              verification and reporting purposes. The application does not
              use location data for advertising purposes.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">
              5. Data Sharing
            </h2>
            <p>
              DBSkills does not sell, rent, or trade personal information with
              third parties. Information may be shared with authorized
              administrators or service providers when necessary to operate
              the attendance system, or when required by applicable law.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">
              6. Data Security
            </h2>
            <p>
              We implement reasonable technical and organizational security
              measures to protect user data from unauthorized access,
              alteration, disclosure, or destruction. However, no method of
              electronic storage or transmission is completely secure.
            </p>
          </section>

          {/* IMPORTANT: Added for Google Play data retention requirement */}
          <section>
            <h2 className="text-2xl font-semibold mb-3">
              7. Data Retention and Deletion
            </h2>
            <p className="mb-3">
              DBSkills Attendance retains personal information, attendance
              records, and location information only for as long as necessary
              to provide attendance management services, maintain records, and
              meet legitimate organizational and legal requirements.
            </p>

            <p className="mb-3">
              When personal information is no longer required, it will be
              securely deleted or anonymized in accordance with our data
              retention practices.
            </p>

            <p>
              Users may request access to, correction of, or deletion of their
              personal information by contacting us using the contact details
              provided in this Privacy Policy. Deletion requests may be subject
              to applicable legal or organizational record-keeping
              requirements.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">
              8. User Rights
            </h2>
            <p>
              Users may request access, correction, or deletion of their
              personal information by contacting us. We will review and process
              requests in accordance with applicable laws and organizational
              requirements.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">
              9. Changes to This Policy
            </h2>
            <p>
              We may update this Privacy Policy periodically. Changes will be
              posted on this page with an updated revision date.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">
              10. Contact Us
            </h2>
            <div className="bg-gray-100 p-4 rounded-lg">
              <p>
                <strong>DBSkills</strong>
              </p>
              <p>Email: contactus@dbskills.com</p>
              <p>Website: https://dbskills.com</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}